module.exports = __webpack_public_path__ + "media/PAG82-05.a94a3a1f.mp3";